import React from 'react'
// import LogoSvg from "assets/svg/logo";
import bbcSVG from 'assets/images/new-homepage-assets/desktop/bbc_logo.svg'
import leftQuote from 'assets/images/quote-left.svg'

const Card1 = ({ background, invertedComma }) => {
  return (
    <div className="flex">
      <div>
        {invertedComma && <img src={leftQuote} className="mt-6 sm:ml-8" />}
      </div>
      <div
        className={`right ${background ? background : 'bg-white'
          } pl-[26px]  p-6 sm:w-[393px] relative sm:mt-0 mt-8 sm:rounded-[20px]`}
      // style="box-shadow: 0px 6px 10px #00000029; border-radius: 22px;"
      >
        {invertedComma ? (
          ''
        ) : (
          <p className="font-medium text-[22px] font-sans">
            "Helpful
            <br /> cooperation"
          </p>
        )}
        <p className="text-[#00173A] font-sans leading-relaxed hidden sm:block mb-24">
          A translation company well equipped <br /> with knowledge of hundreds
          of <br /> different languages - speedy return <br /> &amp; reasonably
          priced.
        </p>
        <p className="text-[#00173A] font-sans leading-relaxed pt-5 sm:hidden">
          A translation company well <br /> equipped with knowledge of <br />
          hundreds of different <br /> languages - speedy return <br /> &amp;
          reasonably priced.
        </p>
        <div className="pt-12">
          <img src={bbcSVG} alt="" />
          <p className="text-[18px] font-medium font-secondary pt-3">
            Katherine Lindsay
            {invertedComma ? (
              <>
                <span className="text-[18px] font-medium font-secondary">
                  ,
                </span>
                <a
                  href="https://www.trustpilot.com/users/60db02325f811c001128d575"
                  target="_blank"
                  className="sm:ml-3 text-orange bold block sm:inline-block"
                >
                  BBC
                </a>
              </>
            ) : (
              ''
            )}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Card1
